import React from 'react';
import styles from './BrokerIdLogo.module.scss';
import { brokerWiseAppBrokerList } from '../../../data/broker-wise-app-broker-list';
import { moduleBrokerName } from '../../../module-params';

function useBrokerLogo() {
  const targetBrokerLogo =
    moduleBrokerName &&
    brokerWiseAppBrokerList.find((item) => item.name === moduleBrokerName);

  return targetBrokerLogo || {};
}

const BrokerIdLogo = () => {
  const { name, logo } = useBrokerLogo();

  if (!logo) {
    return <></>;
  }

  return (
    <div className={styles.BrokerIdLogo}>
      <img src={logo} alt={name} />
    </div>
  );
};

export default BrokerIdLogo;
